import React from 'react';
import {
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import {
  RichTextAlertDescription,
} from 'Views/Page/Content/Modal/Layouts/JobBasicInformationStep/Layout/RichTextAlertDescription';

const Layout = () => {
  return (
    <PXFormModalWrapper>
      <MetaControlField
        attr="espMatchesDescription"
        CustomProps={{
          Component: RichTextAlertDescription,
        }}
      />
      <MetaControlField attr="matchPercentage" />
      <FDStack direction="column" spacing={1}>
        <FDTitleText value="Account information" />
        <FDStack direction="row" spacing={2}>
          <MetaControlField attr="employerContributionRetirementAccount" flexGrow={1} />
        </FDStack>
      </FDStack>
    </PXFormModalWrapper>
  );
};

export default Layout;
